type Callback = (...args: any[]) => void;

export class EventDispatcher {
  private subscribers: { [event: string]: Callback[] } = {};

  subscribe(event: string, callback: Callback): void {
    if (!this.subscribers[event]) {
      this.subscribers[event] = [];
    }
    this.subscribers[event].push(callback);
  }

  unsubscribe(event: string, callback: Callback): void {
    if (this.subscribers[event]) {
      this.subscribers[event] = this.subscribers[event].filter(
        (subscriber) => subscriber !== callback
      );
    }
  }

  dispatch(event: string, ...args: any[]): void {
    if (this.subscribers[event]) {
      this.subscribers[event].forEach((callback) => {
        callback(...args);
      });
    }
  }
}

export const dispatchGlobalError = (error: Error) => {
  const event = new CustomEvent("GLOBAL_ERROR", { detail: error });
  window.dispatchEvent(event);
};
